var stringToSequence = function stringToSequence(doc) {
  var sepRe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : /[a-zA-ZÀ-ÿ]+/g;

  if (typeof sepRe === "string") {
    sepRe = new RegExp(sepRe, "g");
  }

  var m;
  var indices = [0];

  do {
    m = sepRe.exec(doc);

    if (m) {
      indices.push(m.index);
      indices.push(m.index + m[0].length);
    }
  } while (m);

  indices = indices.concat([doc.length]);
  return indices.map(function (_, i) {
    return {
      text: doc.slice(indices[i], indices[i + 1]),
      textId: Math.random().toString(36).slice(-6)
    };
  }).filter(function (s) {
    return s.text.length > 0;
  });
};

export default stringToSequence;